import { Link, useLocation } from "react-router-dom";
import { ChevronLeft } from "lucide-react";
import { Button } from "./ui/button";
import { useLanguage } from "../lib/i18n/LanguageContext";
import LanguageSwitcher from "./LanguageSwitcher";
import ThemeToggle from "./ThemeToggle";
import { getNavigationConfig } from "@/lib/constants/navigation";

function Header() {
  const location = useLocation();
  const { t } = useLanguage();
  const navConfig = getNavigationConfig(location.pathname);

  return (
    <header className="app-header flex items-center justify-between p-2 relative">
      {/* Left side - Back button or spacer */}
      <div className="header-left flex items-center justify-start min-w-0">
        {navConfig.backRoute ? (
          <Link to={navConfig.backRoute} className="back-button-link">
            <Button
              variant="ghost"
              size="sm"
              className="flex items-center gap-1 text-gray-600 dark:text-gray-400 hover:text-black dark:hover:text-white p-1"
            >
              <ChevronLeft size={20} />
              {navConfig.backLabel && (
                <span className="text-sm hidden sm:inline">
                  {t(navConfig.backLabel as any)}
                </span>
              )}
            </Button>
          </Link>
        ) : (
          <div className="w-8" /> // Spacer for alignment
        )}
      </div>

      {/* Center - Brand title or page title */}
      <div className="header-center flex-1 flex justify-center">
        {navConfig.showBrandTitle ? (
          <h1 className="brand-title text-lg sm:text-xl lg:text-2xl font-light tracking-wider text-center">
            {t("brandName")}
          </h1>
        ) : navConfig.pageTitle ? (
          <h1 className="page-title text-lg sm:text-xl font-light text-center">
            {t(navConfig.pageTitle as any)}
          </h1>
        ) : null}
      </div>

      {/* Right side - Theme toggle and Language switcher */}
      <div className="header-right flex items-center justify-end gap-2 min-w-0">
        <ThemeToggle />
        <LanguageSwitcher />
      </div>
    </header>
  );
}

export default Header;
